import { render, staticRenderFns } from "./KaiFormErrors.vue?vue&type=template&id=5f5a560c&"
import script from "./KaiFormErrors.vue?vue&type=script&lang=ts&"
export * from "./KaiFormErrors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports